import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getPartnerNoPayoutRationales } from 'src/api/no-payout-rationales';
import { enqueueSnackbarAction } from 'src/store/notifications/actions';
import {
    FETCH_PARTNER_NO_PAYOUT_RATIONALES,
    requestPartnerNoPayoutRationales,
    requestPartnerNoPayoutRationalesSuccess,
} from './actions';

function* fetchPartnerNoPayoutRationalesSaga(): SagaIterator {
    yield put(requestPartnerNoPayoutRationales());

    const { error, response } = yield call(getPartnerNoPayoutRationales);

    if (error) {
        yield put(
            enqueueSnackbarAction({
                message: `Fehler: Partner-NichtAuszahlungsgründe konnten nicht geladen werden --- ${error.message}`,
                options: { key: new Date().getTime() + Math.random(), variant: 'error' },
            })
        );
    } else {
        yield put(requestPartnerNoPayoutRationalesSuccess(response));
    }
}

export function* generateFetchPartnerNoPayoutRationalesWatcher() {
    yield takeLatest(FETCH_PARTNER_NO_PAYOUT_RATIONALES, fetchPartnerNoPayoutRationalesSaga);
}
